<template>
  <div class="layout--public-profile">
    <router-view v-if="ready" />
  </div>
</template>

<script>
import { mapState } from "vuex";

// Layout enxuto do editor do perfil publico: tela cheia, sem as abas do
// dashboard. Carrega a empresa (cor white-label) e os dados do talento, como o
// Dashboard.vue faz, sem o fluxo de etapas e de termos.
export default {
  name: "PublicProfileLayout",
  data: () => ({ ready: false }),
  computed: {
    ...mapState("company", ["company"]),
    ...mapState("basicInfo", ["basicInfo"]),
  },
  watch: {
    "company.base_hexcolor"() {
      this.updatePrimaryColor();
    },
  },
  async created() {
    window.scroll(0, 0);
    const label = this.$route.params.company_label || localStorage.getItem("label");
    try {
      if (label) {
        await this.$store.dispatch("company/fetchCompany", label);
      }
    } catch (e) {
      // Sem empresa seguimos com a cor padrao; a tela nao pode ficar em branco.
    }
    this.updatePrimaryColor();
    this.ready = true;
    this.loadTalentData(label);
  },
  methods: {
    updatePrimaryColor() {
      const color = this.company && this.company.base_hexcolor;
      if (color) this.$vs.theme({ primary: color !== "#ffffff" ? color : "#000" });
    },
    async loadTalentData(label) {
      // O store e persistido na sessao: so busca se ainda nao tem o talento.
      const hasTalent = this.basicInfo && Object.keys(this.basicInfo).length > 0;
      if (hasTalent || !label) return;
      try {
        const payload = await this.$http.get(`api/v1/talent/${label}/user/talent`);
        await this.$store.dispatch("step/parseStepsInformation", payload);
      } catch (e) {
        // O editor funciona so com o EditorState; os dados do talento sao extra.
      }
    },
  },
};
</script>

<style lang="scss">
.layout--public-profile {
  min-height: 100vh;
  background: #fff;
}
</style>
